import { StepsButtons } from "@/components/button/steps-button";
import { FullScreenBackgroundContainer } from "@/components/container/full-screen-background-container";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";

export default function ProfilingToldWhatToEat() {
  const { info } = useStepRouteInfo();
  return (
    <FullScreenBackgroundContainer
      imageClassName="bg-[url(/assets/images/pancake.jpeg)]"
      backdrop={true}
    >
      <div className="flex flex-col items-center gap-4 justify-center flex-1 text-white">
        <h2 className="font-bold text-center">
          Told What to Eat. Never What to Track
        </h2>
        <p className="text-center">
          We know you don’t have time to think about food—so we count every
          calorie and macro for you. Just follow the plan.
        </p>
      </div>

      <StepsButtons nextPath={info?.nextPath} />
    </FullScreenBackgroundContainer>
  );
}
